import React from 'react';
import { useTranslation } from 'react-i18next';

const RequisitionsReportsTableItem = ({ item, index }) => {
  const [t] = useTranslation('global');

  return (
    <div className="grid grid-cols-12 gap-3 border-t px-4 py-2 cursor-pointer items-center hover:bg-[#251658]/5 hover:font-bold">
      <div className="text-center col-span-1 text-[#251658] text-xs">
        {index+1}
      </div>
      <div className="text-center col-span-1 text-[#251658] text-xs">
        {item.requisition_master_id || '-'}
      </div>
      <div className="text-center col-span-4 text-[#251658] text-xs">
        {item.warehouse?.name_ar || '-'}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {item.qty || '-'}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
    {item.type?.trim() == 'PASH'
        ? t('requisition.increase')
        : item.type?.trim() == 'PULL'
        ? t('requisition.decrease')
        : '-'}
</div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
        {item.created_at && item.created_at.split('T')[0] || '-'}
      </div>
      </div>
     
  );
};

export default RequisitionsReportsTableItem;
